export default __webpack_public_path__ + "static/media/14219-runj.44a7e8f1.pdf";